import { render, staticRenderFns } from "./addOrEditUser.vue?vue&type=template&id=b9bae720&scoped=true&"
import script from "./addOrEditUser.vue?vue&type=script&lang=js&"
export * from "./addOrEditUser.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditUser.vue?vue&type=style&index=0&id=b9bae720&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bae720",
  null
  
)

export default component.exports